export const defaultBreadcrumbList = [
  {
    path: "",
    label: "",
    current: false,
  },
];
